/* eslint-disable react/jsx-pascal-case */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Privacy_Policy_Modal from "../Component/Privacy_Policy_Modal";
import Terms_Modal from "../Component/Terms_Modal";
import { Content_Text } from "../Component/theme";
import ic_right_white from "../image/ic_right_white.png";
import image_home_bottom from "../image/image_home_bottom.png";
import image_main_mid from "../image/image_main_mid.png";
import image_main_mid2 from "../image/image_main_mid2.png";
import image_main_mid3 from "../image/image_main_mid3.png";
import image_process from "../image/image_process.png";
import image_process2 from "../image/image_process2.png";
import image_scroll_down from "../image/image_scroll_down.png";
import image_side_back from "../image/image_side_back.png";
import img_client from "../image/img_client3.png";
import img_main_top from "../image/img_main_top.png";
import Logo_Linkcampus from "../image/Logo_Linkcampus.png";
import Logo_Linkcampus2 from "../image/Logo_Linkcampus2.png";

import Footer_FMS from "./Footer_FMS";
import Side_FMS from "./Side_FMS";

const Container = styled.div`
  background-color: white;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-areas:
    "header header header"
    "main main main"
    "footer footer footer";
  grid-template-rows: 80px 1fr 400px;
  grid-template-columns: 200px 1fr 200px;
  @media (max-width: 800px) {
    grid-template-rows: 40px 1fr 400px;
  }
`;
const Header = styled.header`
  grid-area: header;
  background: ${(props) =>
    props.$scroll > 800 ? "white" : 'rgba("0,0,0,0.5")'};
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 100%;
  padding: 10px;
  z-index: 10;
  @media (max-width: 800px) {
    padding: 0px;
    background: ${(props) =>
      props.$scroll > 330 ? "white" : 'rgba("0,0,0,0.5")'};
  }
`;
const Header_div = styled.div`
  display: flex;
  color: black;
  align-items: center;
  max-width: 1280px;
  width: 100%;
  padding: 15px 20px;
`;
const Logo_img = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  cursor: pointer;
  margin-right: 50px;
  height: 40px;
  @media (max-width: 800px) {
    margin-right: 30px;
    height: 20px;
  }
`;
const Top_Button = styled.span`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  font-size: 20px;
  margin-left: 30px;
  cursor: pointer;
  color: ${(props) => (props.$scroll > 800 ? "#C0C0C0" : "white")};
  transition: color 0.2s ease;
  &:hover {
    color: black;
  }
  @media (max-width: 800px) {
    font-size: 12px;
    margin-left: 15px;
    color: ${(props) => (props.$scroll > 300 ? "#C0C0C0" : "white")};
  }
`;
const Main = styled.main`
  grid-area: main;
  justify-content: center;
  align-items: flex-start;
  padding-top: 10px;
  background-color: white;
`;
const Main_div = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  position: relative;
`;
const Main_div2 = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  position: relative;
  background-color: white;
  padding-bottom: 200px;
  @media (max-width: 800px) {
    padding-bottom: 30px;
  }
`;
const Main_div3 = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  position: relative;
  background-color: #fafafa;
`;
const Main_init_div = styled.div`
  z-index: 1;
  display: flex;
  width: 100%;
  max-width: 1280px;
  padding-top: 200px;
  flex-direction: row; /* 기본 방향은 행 */

  @media (max-width: 800px) {
    /* flex-direction: column; 모바일 화면에서는 열 방향 */
    padding-top: 50px;
    padding-bottom: 0px;
  }
`;
const Main_init_div2 = styled.div`
  z-index: 2;
  display: flex;
  width: 100%;
  height: 700px;
  max-width: 1280px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-bottom: 50px;

  @media (max-width: 800px) {
    height: 250px;
  }
`;

const Main_init_div3 = styled.div`
  z-index: 2;
  display: flex;
  width: 100%;
  height: 500px;
  max-width: 1280px;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media (max-width: 800px) {
    height: 250px;
  }
`;
const Main_init_div4 = styled.div`
  z-index: 2;
  display: flex;
  width: 100%;
  height: 700px;
  max-width: 640px;
  padding: 50px;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media (max-width: 800px) {
    height: 350px;
    padding: 15px;
  }
`;

const Main_Content = styled.div`
  flex: 1;
  display: grid;
  justify-content: ${(props) => (props.$left ? "flex-start" : "center")};
  align-self: ${(props) => (props.$center ? "center" : "")};
  text-align: ${(props) => (props.$left ? "flex-start" : "center")};

  @media (max-width: 1500px) {
    padding: 0px 60px 20px 60px;
    /* text-align: center; */
  }
  @media (max-width: 800px) {
    padding: 0px 15px 20px 15px;
    /* text-align: center; */
  }
`;

const Main_Button = styled.button`
  z-index: 3;
  position: absolute;
  display: flex;
  background-color: ${(props) =>
    props.$black ? "black" : "rgba(255,255,255,0.2)"};
  padding: 11px 22px 11px 32px;
  bottom: 100px;
  border-radius: 100px;
  border-style: solid;
  border-width: 2px;
  border-color: white;
  align-items: center;
  justify-self: center;
  @media (max-width: 800px) {
    padding: 7px 13px 7px 20px;
    bottom: 60px;
    border-width: 1px;
  }
  cursor: pointer;
  transition: background-color 0.2s ease;
  &:hover {
    background-color: black;
    ${Content_Text} {
      transition: color 0.3s ease;
    }
  }
`;
const Image = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
`;

const Image2 = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  width: 100%;
  margin-top: 20px;
  justify-self: center;
`;

const Footer = styled.footer`
  grid-area: footer;
  background: #464646;
  color: white;
  display: grid;
  align-items: flex-start;
  justify-content: center;
  white-space: pre-line;
  text-align: center;
`;

const Main_Top_IMG = styled(Image)`
  position: absolute;
  width: 100%;
  height: 125%;
  object-fit: cover;
  @media (max-width: 800px) {
    width: 100%;
    height: 135%;
  }
`;

const Info_IMG = styled(Image)`
  width: 600px;
  @media (max-width: 800px) {
    width: 200px;
  }
`;

const Process_IMG = styled(Image)`
  display: flex;
  @media (max-width: 800px) {
    display: none;
  }
`;
const Process_IMG3 = styled(Image)`
  display: none;
  @media (max-width: 800px) {
    display: flex;
  }
`;

const Side_Back = styled(Image)`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
  object-fit: cover;
`;

const Side_Back2 = styled(Image)`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
  object-fit: cover;
  @media (max-width: 800px) {
    object-fit: fill;
  }
`;

const Right_Image = styled(Image)`
  height: 30px;
  @media (max-width: 800px) {
    height: 15px;
  }
`;
const Scroll_Down_Image = styled(Image)`
  position: absolute;
  bottom: 15px;
  height: 50px;
  @media (max-width: 800px) {
    height: 25px;
  }
`;

const Image_Home_Bottom = styled(Image)`
  margin-top: 80px;
  width: 80%;
  justify-self: center;
  margin-bottom: 300px;
  @media (max-width: 800px) {
    width: 90%;
    margin-top: 40px;
    margin-bottom: 100px;
  }
`;
function Home() {
  const navigation = useNavigate();
  const [privacy_policy, set_Privacy_Policy] = useState(false);
  const [terms, set_Terms] = useState(false);
  const close_privacy_policy = () => set_Privacy_Policy(false);
  const close_terms = () => set_Terms(false);
  const [select, set_Select] = useState("앱");
  const [call, set_Call] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const go_Home = () => {
    navigation("/FMS/");
    window.scrollTo({ top: 0 });
  };
  const go_About = () => {
    navigation("/FMS/about");
    window.scrollTo({ top: 0 });
  };
  const go_Platform = () => {
    navigation("/FMS/Platform");
    window.scrollTo({ top: 0 });
  };
  const go_Info = () => {
    navigation("/FMS/Info");
    window.scrollTo({ top: 0 });
  };
  const go_Process = () => {
    navigation("/FMS/Process_FMS");
    window.scrollTo({ top: 0 });
  };
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  // 사이즈 체크
  useEffect(() => {
    // console.log(event_show);
    // Cookie.remove("event_show");

    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 우클릭 금지
  useEffect(() => {
    const handleRightClick = (event) => {
      event.preventDefault();
    };

    document.addEventListener("contextmenu", handleRightClick);
    return () => {
      document.removeEventListener("contextmenu", handleRightClick);
    };
  }, []);

  const [scrollAmount, setScrollAmount] = useState(0);
  const [logoSrc, setLogoSrc] = useState(Logo_Linkcampus2);

  // 스크롤 이벤트 핸들러

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  const handleScroll = () => {
    setScrollAmount(window.scrollY);
  };

  useEffect(() => {
    // 화면 크기와 스크롤 이벤트 리스너 등록
    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (windowWidth <= 800) {
      setLogoSrc(scrollAmount >= 330 ? Logo_Linkcampus : Logo_Linkcampus2);
    } else {
      setLogoSrc(scrollAmount >= 800 ? Logo_Linkcampus : Logo_Linkcampus2);
    }
  }, [windowWidth, scrollAmount]);

  return (
    <Container width={windowSize.width} height={windowSize.height}>
      <Header $scroll={scrollAmount}>
        <Header_div>
          <Logo_img
            onClick={() => {
              go_Home();
            }}
            src={logoSrc}
            alt={Logo_Linkcampus2}
          />
          <Top_Button
            $scroll={scrollAmount}
            onClick={() => {
              go_Info();
            }}
          >
            회사소개
          </Top_Button>
          <Top_Button
            $scroll={scrollAmount}
            onClick={() => {
              go_Process();
            }}
          >
            프로세스
          </Top_Button>
          <Top_Button
            $scroll={scrollAmount}
            onClick={() => {
              go_Platform();
            }}
          >
            플랫폼
          </Top_Button>
          <Top_Button
            $scroll={scrollAmount}
            onClick={() => {
              go_About();
            }}
          >
            제작문의
          </Top_Button>
        </Header_div>
      </Header>
      {/* <Sidebar>사이드바 영역</Sidebar> */}
      <Main>
        <Main_div>
          <Main_init_div2>
            <Content_Text
              $white
              $xxlarge
              $xbold
              style={{ textAlign: "center" }}
            >
              전담 매니저가 관리하는 FMS를 만나보세요.
            </Content_Text>
            <Content_Text
              $white
              $large
              style={{ marginTop: 5, textAlign: "center" }}
            >
              링크캠퍼스는 체계적인 시스템을 통해 최고의 FMS를 제작해드립니다.
            </Content_Text>
          </Main_init_div2>
          <Main_Top_IMG src={img_main_top} alt={img_main_top} />
          <Main_Button
            onClick={() => {
              go_About();
            }}
          >
            <Content_Text $white $xlarge>
              문의하기
            </Content_Text>
            <Right_Image src={ic_right_white} alt={ic_right_white} />
          </Main_Button>
          <Scroll_Down_Image src={image_scroll_down} alt={image_scroll_down} />
        </Main_div>

        <Main_div2>
          <Side_Back src={image_side_back} alt={image_side_back} />
          <Main_init_div>
            <Main_Content>
              <Content_Text>링크캠퍼스를 통해 FMS를 운영하고 있는</Content_Text>
              <Content_Text $xxlarge $xxbold>
                42개의 클라이언트사가 있습니다.
              </Content_Text>
              <Image2 src={img_client} alt={img_client} />
            </Main_Content>
          </Main_init_div>
        </Main_div2>
        <Main_div3>
          <Main_init_div3>
            <Content_Text
              $white
              $xxlarge
              $xbold
              style={{ textAlign: "center" }}
            >
              전담매니저 배정으로 빠른 상담과 사용자 메뉴얼을 제공받아보세요.
            </Content_Text>
            <Content_Text
              $white
              $large
              style={{ marginTop: 5, textAlign: "center" }}
            >
              전담매니저가 최적의 운영관리를 할 수 있도록 도와드립니다.
            </Content_Text>
          </Main_init_div3>
          <Main_Top_IMG src={image_main_mid} alt={image_main_mid} />
        </Main_div3>
        <Main_div2>
          <Side_Back2 src={image_side_back} alt={image_side_back} />
          <Main_init_div>
            <Main_Content>
              <Content_Text $xbold $xxlarge style={{ marginBottom: 4 }}>
                시설 관리를 FMS로 관리하는 이유
              </Content_Text>
              <Content_Text>
                많은 조직에서 FMS를 도입하는데는 이유가 있습니다.
              </Content_Text>
              <Process_IMG
                style={{
                  width: "60%",
                  justifySelf: "center",
                  marginBottom: 60,
                  paddingTop: 150,
                }}
                src={image_process}
                alt={image_process}
              />
              <Process_IMG3
                style={{
                  width: "80%",
                  justifySelf: "center",
                  marginBottom: 60,
                  marginTop: 50,
                }}
                src={image_process2}
                alt={image_process2}
              />
            </Main_Content>
          </Main_init_div>
        </Main_div2>
        <Main_div3>
          <Main_init_div4>
            <Content_Text
              $white
              $xxlarge
              $xbold
              style={{ width: "100%", textAlign: "left" }}
            >
              한 눈에 보는 통합 시설관리
            </Content_Text>
            <Content_Text
              $white
              $large
              style={{
                marginTop: 5,
                textAlign: "left",
                width: "100%",
              }}
            >
              흩어져 있던 모든 관리 현황을 한 눈에 파악할 수 있어 효율적으로
              통합관리가 가능합니다.
            </Content_Text>
          </Main_init_div4>
          <Main_init_div4>
            <Info_IMG src={image_main_mid3} alt={image_main_mid3} />
          </Main_init_div4>
          <Main_Top_IMG src={image_main_mid2} alt={image_main_mid2} />
        </Main_div3>
        <Main_div3 style={{ marginTop: 0 }}>
          <Side_Back src={image_side_back} alt={image_side_back} />

          <Main_init_div>
            <Main_Content>
              {windowWidth > 800 ? (
                <>
                  <Content_Text $xbold $xxlarge style={{ marginBottom: 4 }}>
                    종이로만 있던 서류들, 이제 디지털로 전환해보세요.
                  </Content_Text>
                  <Content_Text>
                    FMS만 있다면 언제, 어디서나 통합 관리가 가능합니다.
                  </Content_Text>
                </>
              ) : (
                <>
                  <Content_Text $xbold $xxlarge>
                    종이로만 있던 서류들,
                  </Content_Text>
                  <Content_Text $xbold $xxlarge style={{ marginBottom: 4 }}>
                    이제 디지털로 전환해보세요.
                  </Content_Text>
                  <Content_Text>
                    FMS만 있다면 언제, 어디서나 통합 관리가 가능합니다.
                  </Content_Text>
                </>
              )}

              <Image_Home_Bottom
                src={image_home_bottom}
                alt={image_home_bottom}
              />
            </Main_Content>
          </Main_init_div>
        </Main_div3>
        {/* <Fixed_Div>
          <Side_Btn
            onClick={() => {
              go_About();
            }}
            src={ic_제작문의}
            alt={ic_제작문의}
          />
          <Side_Bar />
          <Side_Btn
            onClick={() => {
              go_Platform();
            }}
            src={ic_플랫폼}
            alt={ic_플랫폼}
          />
          <Side_Bar />
          <Side_Btn
            onClick={() => {
              Call_Click();
            }}
            src={ic_고객센터}
            alt={ic_고객센터}
          />
          <Call_View show={call}>
            <Call_Init_Div>
              <Content_Text $white $xbold>
                0507-1336-7115
              </Content_Text>
              <Content_Text style={{ marginTop: 5 }} $lightGray $xsmall $bold>
                평일 09:30 ~ 18:30
              </Content_Text>
              <Content_Text $lightGray $xsmall $bold>
                주말 및 공휴일 휴무
              </Content_Text>
            </Call_Init_Div>
            <Call_Init_Right
              onClick={() => {
                Call_Click();
              }}
            >
              <Image
                style={{ width: 30, height: 30 }}
                src={ic_right_white}
                alt={ic_right_white}
              />
            </Call_Init_Right>
          </Call_View>
        </Fixed_Div> */}
        <Side_FMS />
      </Main>
      <Footer>
        <Footer_FMS />
      </Footer>
      <Privacy_Policy_Modal
        show={privacy_policy}
        onClose={close_privacy_policy}
      />
      <Terms_Modal show={terms} onClose={close_terms} />
    </Container>
  );
}

export default Home;
